/* fb-chrome.js — FreshBox header behaviour.
   Mobile off-canvas drawer (open/close + single-open accordion) and the
   mobile search-row toggle. Desktop hover/mega-nav is pure CSS (fb-nav.css). */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var drawer = document.querySelector('[data-fbd]');
  var scrim  = document.querySelector('[data-fbd-scrim]');

  function openDrawer() {
    if (!drawer) return;
    // Las miniaturas de categoría viajan en data-bg (no en style=) para no bajarlas en
    // cada carga de página: se asignan la primera vez que se abre el drawer.
    if (!drawer.dataset.bgDone) {
      drawer.dataset.bgDone = '1';
      drawer.querySelectorAll('[data-bg]').forEach(function (el) {
        el.style.backgroundImage = "url('" + el.getAttribute('data-bg') + "')";
      });
    }
    if (scrim) { scrim.hidden = false; }
    // force reflow so the transition runs from the hidden state
    if (scrim) { void scrim.offsetWidth; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (scrim) scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    // El cajón vive dentro de .site-header (z-index 1110) y la franja de anuncios es
    // fija con z-index 1120: tapaba la X del cajón. Con el cajón abierto el header sube
    // por encima de la franja (html.fbd-open, fb-chrome.css).
    document.documentElement.classList.add('fbd-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (scrim) {
      scrim.classList.remove('is-open');
      setTimeout(function () { scrim.hidden = true; }, 320);
    }
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('fbd-open');
  }

  // hamburger(s) open the drawer
  header.querySelectorAll('.site-header-menu-toggle, [data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  if (scrim) scrim.addEventListener('click', closeDrawer);
  if (drawer) {
    drawer.querySelectorAll('[data-fbd-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    // single-open accordion
    drawer.querySelectorAll('[data-fbd-toggle]').forEach(function (head) {
      head.addEventListener('click', function () {
        var cat = head.closest('[data-fbd-cat]');
        if (!cat) return;
        var isOpen = cat.classList.contains('is-open');
        drawer.querySelectorAll('[data-fbd-cat].is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var h = o.querySelector('[data-fbd-toggle]');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) { cat.classList.add('is-open'); head.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  // mobile search row toggle
  var searchInput = header.querySelector('[data-fbsearch-input]');
  function toggleSearch() {
    var open = header.classList.toggle('mobile-search-open');
    var main = header.querySelector('.site-header-main');
    if (main) main.classList.toggle('mobile-search-open', open);
    if (open && searchInput) { setTimeout(function () { searchInput.focus(); }, 60); }
  }
  header.querySelectorAll('.site-header-mobile-search-button, [data-mobile-search-button]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); toggleSearch(); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      header.classList.remove('mobile-search-open');
      var main = header.querySelector('.site-header-main');
      if (main) main.classList.remove('mobile-search-open');
    }
  });

  /* ---- smart-sticky: hide the header on scroll-DOWN, reveal it on scroll-UP ----
     Near the top it's always shown. Once past HIDE_AFTER, scrolling down slides it
     up out of view ("stays behind"); the first up-scroll pops it back down. */
  (function () {
    var lastY = window.pageYOffset || 0, ticking = false;
    var TOP = 8, HIDE_AFTER = 90;

    // Header is position:fixed → a spacer of equal height keeps page content from
    // sliding underneath it. Its height is reserved by CSS from first paint
    // (.fb-head-spacer in fb-chrome.css, per breakpoint) so it's correct with zero JS.
    // JS only overrides it with a PLAUSIBLE measured value: a pre-CSS reflow can briefly
    // measure the whole header including the off-canvas drawer while it's still in-flow
    // (~700px). Committing that and only correcting on `window.load` used to jump the
    // page ~650px on slow connections (load fires ~22s in on 4G) = the CLS 0.697.
    // El espaciador ya viene en el HTML (static-header.liquid): este guion va con defer y
    // crearlo aquí lo metía tarde y hacía brincar la página. Se crea solo si falta.
    var spacer = header.previousElementSibling;
    if (!spacer || !spacer.classList.contains('fb-head-spacer')) {
      spacer = document.createElement('div');
      spacer.className = 'fb-head-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      if (header.parentNode) header.parentNode.insertBefore(spacer, header);
    }
    function sizeSpacer() {
      var h = header.offsetHeight;
      // Reject the ~700px garbage; let the CSS-reserved height (57/110px) stand instead.
      if (h > 24 && h < 240) { spacer.style.height = h + 'px'; }
    }
    sizeSpacer();
    window.addEventListener('load', sizeSpacer);
    window.addEventListener('resize', function () { window.requestAnimationFrame(sizeSpacer); });

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y <= TOP) {
        header.classList.remove('fb-head-hidden');
        header.classList.remove('site-header-sticky--scrolled');
      } else {
        header.classList.add('site-header-sticky--scrolled');
        if (y > lastY && y > HIDE_AFTER && !header.classList.contains('mobile-search-open')) {
          header.classList.add('fb-head-hidden');           // scrolling down → hide
        } else if (y < lastY) {
          header.classList.remove('fb-head-hidden');          // scrolling up → reveal
        }
      }
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  })();

  /* ---- add-to-cart celebration: reveal header + cart wiggle + bubble pop + 1-up "+N" ---- */
  function celebrateAdd(delta) {
    header.classList.remove('fb-head-hidden'); // pop the header into view if hidden
    var btn = header.querySelector('.site-header-cart--button');
    var count = header.querySelector('.site-header-cart--count');
    if (btn) {
      btn.classList.remove('fb-cart-twiggle'); void btn.offsetWidth; btn.classList.add('fb-cart-twiggle');
      window.setTimeout(function () { btn.classList.remove('fb-cart-twiggle'); }, 700);
      var up = document.createElement('span');
      up.className = 'fb-oneup'; up.setAttribute('aria-hidden', 'true');
      up.textContent = '+' + delta;
      btn.appendChild(up);
      window.setTimeout(function () { if (up.parentNode) up.parentNode.removeChild(up); }, 1550);
    }
    if (count) {
      count.classList.remove('fb-count-bump'); void count.offsetWidth; count.classList.add('fb-count-bump');
      window.setTimeout(function () { count.classList.remove('fb-count-bump'); }, 480);
    }
  }
  function paintCount(n) {
    var el = header.querySelector('.site-header-cart--count');
    if (!el) return;
    el.setAttribute('data-header-cart-count', n > 0 ? n : '');
    el.classList.toggle('visible', n > 0);
  }
  var cartHold = false;
  var latestCount = (function () {
    var el = header.querySelector('.site-header-cart--count');
    return el ? (parseInt(el.getAttribute('data-header-cart-count'), 10) || 0) : 0;
  })();
  // fb-commerce.js drives this: hold the bubble while the "fly-to-cart" image is in
  // flight, then release on arrival so the number + "+N" + wiggle all land together.
  window.fbCart = {
    hold: function () { cartHold = true; },
    // slide the header down first; returns true if it WAS hidden (so the caller waits
    // for the slide before measuring the cart as the fly target)
    reveal: function () {
      var was = header.classList.contains('fb-head-hidden');
      header.classList.remove('fb-head-hidden');
      return was;
    },
    release: function (delta) {
      cartHold = false;
      paintCount(latestCount);
      if (delta > 0) celebrateAdd(delta);
    },
    // celebrate WITHOUT holding the number (used by the PDP/Empire path, whose count
    // is updated by Empire itself — we just animate reveal + wiggle + "+N").
    celebrate: function (delta) { celebrateAdd(delta > 0 ? delta : 1); }
  };

  /* Live cart-count bubble. Empire used to keep this in sync via its StaticHeader
     class, but we detached the header from Empire's section system, so we refresh
     it ourselves: read /cart.js after any cart mutation and on Rebuy cart events.
     The bubble is drawn by `.site-header-cart--count::after { content: attr(data-header-cart-count) }`. */
  var lastCartEventTs = 0; // último cart:updated recibido (con o sin carrito a bordo)
  function refreshCartCount(e) {
    // Si el evento trae el carrito (fb-commerce, cajón, ficha), no hay que volver a pedirlo.
    var c0 = e && e.detail && e.detail.cart;
    if (e && e.type) lastCartEventTs = Date.now();
    if (c0 && typeof c0.item_count === 'number') {
      latestCount = c0.item_count;
      if (!cartHold) paintCount(latestCount);
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        latestCount = (c && c.item_count) || 0;
        if (!cartHold) paintCount(latestCount); // while held, the fly's arrival paints it
      })
      .catch(function () {});
  }
  // Klaviyo "Added to Cart" — the custom AJAX cart bypasses Klaviyo's form-based snippet,
  // so no ATC events were reaching Klaviyo and its pre-checkout abandonment flow couldn't
  // trigger. Piggyback the same fetch passthrough: on a successful /cart/add.js, parse the
  // added line(s) from the response clone and push the event. Handles both response shapes
  // (single line item, or {items:[...]}). No-op when Klaviyo isn't loaded.
  function klaviyoTrackAdd(res) {
    try {
      res.clone().json().then(function (data) {
        var items = (data && data.items) || (data && data.key ? [data] : []);
        var q = window.klaviyo || window._learnq;
        if (!q || !q.push || !items.length) return;
        items.forEach(function (it) {
          q.push(['track', 'Added to Cart', {
            $value: (it.final_line_price != null ? it.final_line_price : it.line_price || 0) / 100,
            AddedItemProductName: it.product_title,
            AddedItemProductID: it.product_id,
            AddedItemVariantID: it.variant_id,
            AddedItemSKU: it.sku,
            AddedItemPrice: (it.final_price != null ? it.final_price : it.price || 0) / 100,
            AddedItemQuantity: it.quantity,
            AddedItemURL: it.url ? (window.location.origin + it.url) : '',
            AddedItemImageURL: it.image || ''
          }]);
        });
      }).catch(function () {});
    } catch (e) {}
  }
  // refresh after cart mutations (passthrough wrapper — only adds side effects)
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      return _fetch.apply(this, arguments).then(function (res) {
        try {
          if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
            // Red de seguridad para guiones que no avisan. Los nuestros disparan cart:updated
            // justo después de su mutación; si ya llegó, esta lectura sobra.
            var t0 = Date.now();
            setTimeout(function () { if (lastCartEventTs < t0) refreshCartCount(); }, 700);
            if (/\/cart\/add(\.js)?/.test(url) && res && res.ok) klaviyoTrackAdd(res);
          }
        } catch (e) {}
        return res;
      });
    };
  }
  ['rebuy:cart.change', 'rebuy:smartcart.ready', 'cart:updated', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, refreshCartCount);
  });

  // ---- logged-in account dropdown (icon + dot → menu) ----
  var acct = header.querySelector('[data-fb-acct]');
  if (acct) {
    var acctToggle = acct.querySelector('[data-fb-acct-toggle]');
    var acctMenu = acct.querySelector('[data-fb-acct-menu]');
    var setAcct = function (open) {
      acctMenu.hidden = !open;
      acctToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    acctToggle.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      setAcct(acctMenu.hidden);
    });
    document.addEventListener('click', function (e) {
      if (!acct.contains(e.target)) setAcct(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setAcct(false);
    });
  }
})();
